import React, {useEffect, useState} from "react";
import {
    Card,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography,
    useMediaQuery,
    useTheme
} from "@material-ui/core";
import AppColors from "../colors/AppColors";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLightbulb} from "@fortawesome/free-solid-svg-icons";
import {green, grey, yellow} from "@material-ui/core/colors";
import Strings from "../lang/Strings";
import {RootStateOrAny, useSelector} from "react-redux";
import {Constants} from "../constants/Constants";
import UsersManager from "../managers/UsersManager";
import axios from "axios";
import EndPoints from "../net/EndPoints";
import RequestUtils from "../utils/RequestUtils";

export default function Referrals(props: any) {

    const theme = useTheme();
    const inMobileView = useMediaQuery(theme.breakpoints.down(731));
    const belowSevenHundred = useMediaQuery(theme.breakpoints.down(700));
    const blackCardsCanGoFlat = useMediaQuery(theme.breakpoints.down(1100));
    const [referralsCount, setReferralsCount] = useState(0);

    const loggedInUserString: string | undefined = useSelector((state: RootStateOrAny) => {
        let liveUserData = state.appReducer[Constants.LOGGED_IN_USER_DATA];
        if (!liveUserData) {
            liveUserData = UsersManager.getLoggedInUser() as string;
        }
        return liveUserData;
    });

    const loggedInUser = loggedInUserString ? JSON.parse(loggedInUserString) : undefined;

    useEffect(() => {
        axios.get(EndPoints.FETCH_PEOPLE_I_REFERRED, {
            headers: RequestUtils.getHeaders()
        }).then(response => {
            let referrals = response["data"]["data"]
            setReferralsCount(referrals.length)
        }).catch(error => {

        });
    }, [referralsCount]);

    return (<div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginLeft: inMobileView ? 20 : 200,
        marginRight: inMobileView ? 20 : 200,
        marginTop: 40,
        marginBottom: 40
    }}>
        <Card
            style={{
                alignSelf: 'center',
                flexDirection: 'row',
                flexWrap: 'wrap',
                display: 'flex',
                padding: belowSevenHundred ? 5 : 2,
                margin: 10,
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 20,
                borderRadius: blackCardsCanGoFlat ? 0 : belowSevenHundred ? 80 : 60,
                backgroundColor: AppColors.BLACK
            }}>
            <FontAwesomeIcon icon={faLightbulb} style={{
                color: AppColors.ACCENT_COLOR,
                flexGrow: 1,
                fontSize: 20,
                marginTop: 2,
                marginLeft: 10,
            }}/>
            <Typography style={{
                flexGrow: 1,
                textAlign: 'center',
                padding: 10,
                fontSize: belowSevenHundred ? 16 : 18,
                color: grey[300]
            }}
                        dangerouslySetInnerHTML={{__html: `<span style='color:${grey[300]};font-size:${belowSevenHundred ? 16 : 18}px;'>You can earn generous commissions from us by referring users to ${Strings.APP_NAME}!</span>`}}/>
        </Card>
        <img src={require('../images/bitcoin_for_all.png')} style={{
            alignSelf: 'center',
        }} alt={"Free Bitcoin Icon"}/>

        <Typography align={"center"} style={{
            color: AppColors.lightenOrDarken("#FF9900", 10),
            fontSize: 20
        }}>We pay referral commissions according to the table below.
        </Typography>

        <div style={{
            display: 'flex',
            width: '70%',
            flexDirection: 'column'
        }}>
            <Typography
                align={"center"}
                style={{
                    background: 'linear-gradient(to bottom,#3192f3 5%,#005bb6 100%)',
                    padding: 10,
                    textAlign: 'center',
                    fontSize: 16,
                    marginTop: 15,
                    fontWeight: 600,
                    color: 'white',
                    borderRadius: '5px 5px 0 0',
                }}>REFERRAL COMMISSION RATES</Typography>
            <Table style={{
                backgroundColor: '#fdfbec',
            }}>
                <TableBody>
                    <TableRow style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        border: '1px solid grey',
                    }}>
                        <TableCell>
                            <Typography style={{
                                fontWeight: 600
                            }}>FREE BTC</Typography>
                        </TableCell>
                        <Typography style={{
                            paddingRight: 10,
                        }}>50% of base prize</Typography>
                    </TableRow>
                    <TableRow style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        border: '1px solid grey',
                    }}>
                        <TableCell>
                            <Typography style={{
                                fontWeight: 600
                            }}>MULTIPLY BTC</Typography>
                        </TableCell>
                        <Typography style={{
                            paddingRight: 10,
                        }}>0.40% of wager / bet</Typography>
                    </TableRow>
                    <TableRow style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        border: '1px solid grey',
                    }}>
                        <TableCell>
                            <Typography style={{
                                fontWeight: 600
                            }}>EARN BTC</Typography>
                        </TableCell>
                        <Typography style={{
                            paddingRight: 10,
                        }}>25% of daily interest</Typography>
                    </TableRow>
                </TableBody>
            </Table>
            <Typography
                align={"center"}
                style={{
                    color: 'white',
                    marginTop: 20,
                    textAlign: 'center'
                }}>Simply promote your referral URL or share it with your friends, and anybody who signs up using it
                will be
                automatically registered as your referral and you will earn commissions whenever they use the
                website!</Typography>
        </div>
        <div style={{
            display: 'flex',
            width: '50%',
            flexDirection: 'column'
        }}>
            <Typography
                align={"center"}
                style={{
                    background: `linear-gradient(to bottom,${green[500]} 5%,${green[700]} 100%)`,
                    padding: 10,
                    textAlign: 'center',
                    fontSize: 16,
                    marginTop: 15,
                    fontWeight: 600,
                    color: 'white',
                    borderRadius: '5px 5px 0 0',
                }}>YOUR REFERRAL URL</Typography>
            <Card>
                <input value={window.location.origin + "?" + Constants.REFERER + "=" + loggedInUser["username"]}
                       style={{
                           width: '100%',
                           padding: 20,
                           textAlign: 'center',
                           fontWeight: 600,
                           fontSize: 17
                       }}/>
            </Card>
        </div>
        <Typography
            align={"center"}
            style={{
                color: 'white',
                paddingTop: 20,
                textAlign: 'center',
                paddingBottom: 20
            }}>Your referral commissions are automatically added to your main account balance (at the top right) in real
            time, as and
            when
            you earn them. The numbers below shows the total number of users you referred
            over time.</Typography>
        <div style={{
            display: 'flex',
            width: '50%',
            flexDirection: 'column'
        }}>
            <Typography
                align={"center"}
                style={{
                    background: `linear-gradient(to bottom,${yellow[700]} 5%,${yellow[900]} 100%)`,
                    padding: 10,
                    textAlign: 'center',
                    fontSize: 16,
                    marginTop: 15,
                    fontWeight: 600,
                    color: 'white',
                    borderRadius: '5px 5px 0 0',
                }}>TOTAL REFERRALS</Typography>
            <Card>
                <input value={referralsCount}
                       style={{
                           width: '100%',
                           padding: 20,
                           textAlign: 'center',
                           fontWeight: 600,
                           fontSize: 17
                       }}/>
            </Card>
        </div>
    </div>);
}